import React from 'react';

type Props = {
  fill?: string;
  stroke?: string;
  className?: string;
  width?: string;
  height?: string;
};

const Flag: React.FC<Props> = ({ className, fill = 'none', stroke = '#0B1215', width = '16', height = '16' }) => (
  <svg className={className} width={width} height={height} viewBox="0 0 16 16" fill={fill} xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.6665 10.0002C2.6665 10.0002 3.33317 9.3335 5.33317 9.3335C7.33317 9.3335 8.6665 10.6668 10.6665 10.6668C12.6665 10.6668 13.3332 10.0002 13.3332 10.0002V2.00016C13.3332 2.00016 12.6665 2.66683 10.6665 2.66683C8.6665 2.66683 7.33317 1.3335 5.33317 1.3335C3.33317 1.3335 2.6665 2.00016 2.6665 2.00016V10.0002Z"
      stroke={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M2.6665 14.6667V10" stroke={stroke} strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default Flag;
